import Card from "../../components/Card";
import { Carousel } from "react-responsive-carousel";
const Project = ({ project }) => {
  return (
    <Card className="portfolio__project">
      <div className="portfolio__project-image">
        <div class="carousel-wrapper">
          <Carousel infiniteLoop useKeyboardArrows autoPlay>
            {project.images &&
              project.images.map((item, i) => (
                <img key={i} src={item} alt={`${i}`} />
              ))}
          </Carousel>
        </div>
      </div>
      <h4>{project.title}</h4>
      <p>{project.desc}</p>
      <div className="portfolio__project-cta">
        <a
          href={project.demo}
          className="btn sm"
          target="_blank"
          rel="noopener noreferrer"
        >
          Demo
        </a>
        <a
          href={project.github}
          className="btn sm primary"
          target="_blank"
          rel="noopner noreferrer"
        >
          Gitbub
        </a>
      </div>
    </Card>
  );
};

export default Project;
